// The colours a day can be given (see services/day-colors), in the order the
// day page's palette lays them out, four across from the right. Each column is
// one family of hues, going round the wheel as it goes down — the reds, the
// yellows and greens, the blues, the violets — with its three bright colours
// over its two soft ones, so the soft rows sit under the colours they soften.
// The grey closes the blues.
//
// A bright colour is a hue only: each theme shades it to read on its own paper
// (--day-color-s and --day-color-l in index.html). A soft one is Papa List's
// own list colour, a value for the light themes and one for the dark, taken
// as it is there (configs/colors in Papa List). The ids are what a day keeps,
// so they must not change; the rest may.
export type IDayColorChoice =
    | { id: string, name: string, hue: number }
    | { id: string, name: string, light: string, dark: string }

export const DAY_COLORS: IDayColorChoice[] = [
    // The bright rows.
    { id: 'pink', hue: 335, name: 'صورتی' },
    { id: 'yellow', hue: 48, name: 'زرد' },
    { id: 'teal', hue: 170, name: 'فیروزه‌ای' },
    { id: 'indigo', hue: 246, name: 'نیلی' },

    { id: 'red', hue: 4, name: 'قرمز' },
    { id: 'pistachio', hue: 85, name: 'پسته‌ای' },
    { id: 'sky', hue: 198, name: 'آسمانی' },
    { id: 'purple', hue: 272, name: 'بنفش' },

    { id: 'orange', hue: 26, name: 'نارنجی' },
    { id: 'green', hue: 135, name: 'سبز' },
    { id: 'blue', hue: 222, name: 'آبی' },
    { id: 'magenta', hue: 305, name: 'سرخابی' },

    // The soft rows.
    { id: 'salmon', light: '#fccfca', dark: '#542f34', name: 'گلبهی' },
    { id: 'straw', light: '#e8e2c5', dark: '#4d4a33', name: 'کاهی' },
    { id: 'powder', light: '#c6dbe7', dark: '#20405e', name: 'آبی کمرنگ' },
    { id: 'lavender', light: '#d6cfed', dark: '#2f3172', name: 'اسطوخودوسی' },

    { id: 'peach', light: '#ecd2b9', dark: '#593924', name: 'هلویی' },
    { id: 'sage', light: '#c9ddd5', dark: '#203f46', name: 'سدری' },
    { id: 'gray', light: '#d0d0d0', dark: '#2c364a', name: 'خاکستری' },
    { id: 'mauve', light: '#dccbe5', dark: '#3c3762', name: 'ارغوانی' },
]
